var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backgroundWrapper",attrs:{"id":"emptyList"}},[_c('h3',[_vm._v(_vm._s(_vm.$t("workspaces.emptyListLabel.assignmentRequest")))]),_c('h3',[_vm._v(_vm._s(_vm.$t("workspaces.emptyListLabel.adminRequest")))])])}
var staticRenderFns = []

export { render, staticRenderFns }